export const SUPPORTED_LANGUAGE_CODES = ['de', 'en', 'fr', 'it'] as const;
export type LanguageCode = typeof SUPPORTED_LANGUAGE_CODES[number];

export const TODAY = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
